"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandeddelivery = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandeddelivery` : '') + (description ? ` desc-brandeddelivery` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandeddelivery"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandeddelivery"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.77 5.74A2 2 0 0 1 17.76 4h28.1a2 2 0 0 1 1.97 1.72l5.85 42A2 2 0 0 1 51.7 50H14l-1.5-2.87-1.75-2.88 5.02-38.5Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "23",
    y: "8",
    width: "18",
    height: "3",
    rx: "1.5",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M62 31a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v23c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V31Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M26.38 35.28a3.47 3.47 0 0 0 1.86 4.42l9.35 5.04-9.55 3.88s-1.75.1-12.75-6.75A145.2 145.2 0 0 0 48.7 12L52 35.5 44.5 43l-13.84-9.61a3.15 3.15 0 0 0-2.52.02 3.33 3.33 0 0 0-1.76 1.86Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M47.65 36.86 30.5 33.28a3.17 3.17 0 0 0-3.56.77 3.39 3.39 0 0 0-.93 2.42 3.47 3.47 0 0 0 1 2.37c.32.31.68.55 1.08.72l9.3 5.01-9.5 3.86s-2.53.15-20.9-12a3.17 3.17 0 0 0-2.44-.44c-.84.2-1.57.73-2.04 1.48a3.47 3.47 0 0 0 .97 4.64c.93.62 20.7 17.9 26.28 17.9C35.36 60 54 52.28 54 52.28V33l-6.35 3.86Z",
    fill: "#F4BD96"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M29.9 34.13a2.19 2.19 0 0 0-2.76 1.26 2.12 2.12 0 0 0 1.24 2.74l.52.2 1.72-3.95-.72-.25Z",
    fill: "#E90B5A"
  }));
};
var _default = exports.default = brandeddelivery;